import { render, staticRenderFns } from "./receiptPayType.vue?vue&type=template&id=2976f78e&scoped=true&"
import script from "./receiptPayType.vue?vue&type=script&lang=js&"
export * from "./receiptPayType.vue?vue&type=script&lang=js&"
import style0 from "./receiptPayType.vue?vue&type=style&index=0&id=2976f78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976f78e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
